import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { authActions, alertActions, registrationActions } from '_store';
import { emailSentLabels, labels } from '_utils/labels';
import { Button, Link, Typography } from '@mui/material';
import { loginValidationSchema } from "_utils/validationSchema";
import { ForgotPassword } from "container/loginPage";
import Grid from "@material-ui/core/Grid";
import { CustomFormControl, ModalPopup, PasswordInput } from "_components";
import msalInstance from "authConfig";
import { ERR_MSG } from "constants/labels";

const Login = () => {
    const [modalState, setModalState] = useState({ open: false, otpOpen: false, manageUseropen: false, error: null });
    const [account, setAccount] = useState(null);
    const [errorMessage,setErrorMessage] = useState("")
    const [isResendVL,setIsResendVL] = useState(false);
    const [email,setEmail] = useState("")
    const dispatch = useDispatch();

    // form validation rules 
    const { register, handleSubmit, control, formState: { errors, isValid }, trigger } = useForm({
        resolver: yupResolver(loginValidationSchema),
        mode: 'onBlur'
    });

    const onSubmit = async ({ Email, Password }) => {
      dispatch(alertActions.clear());
      try {
        setEmail(Email);
        const user = await dispatch(
          authActions.login({ Email, Password }),
        ).unwrap();

        if (!user?.Data?.UserDetails?.jwToken) {
          throw new Error(ERR_MSG["073"]);
        }
        dispatch(authActions.setAuth(user));
      } catch (error) {
        let message = ERR_MSG["073"];

        if (!error.message) {
          if (
            error ===
            "Email verification pending. Follow the instructions in the email for logging into your account."
          ) {
            setIsResendVL(true);
            setErrorMessage(error);
          } else {
            dispatch(
              alertActions.error({
                message: error,
                header: "Login Failed",
                showAfterRedirect: true,
              }),
            );
          }
          return;
        }
        dispatch(
          alertActions.error({
            message,
            header: "Login Failed",
            showAfterRedirect: true,
          }),
        );
      }
    };

    const handleSSOLogin = async () => {
      dispatch(alertActions.clear());
      try {
        await msalInstance.initialize();
        const loginResponse = await msalInstance.loginPopup({
          scopes: ["User.Read"],
        });

        setAccount(loginResponse.account);
        if (loginResponse.account) {
          // Assuming you have a way to determine if the user is internal
          const isInternalUser = determineIfInternalUser(loginResponse.account);
          sessionStorage.setItem(
            "isInternalUser",
            JSON.stringify(isInternalUser),
          );
          const MicroEntraToken = loginResponse.account.idToken;
          const user = await dispatch(
            authActions.loginSSO({ MicroEntraToken }),
          ).unwrap();
          if (!user?.Data?.UserDetails?.jwToken) {
            throw new Error(ERR_MSG["073"]);
          }
          dispatch(authActions.setAuth(user));
        }
      } catch (error) {
        if (
          error?.name === "BrowserAuthError" &&
          error?.errorCode === "user_cancelled"
        )
          return;
        
        dispatch(
          alertActions.error({
            message: error.message ? ERR_MSG["073"] : error,
            header: "Login Failed",
            showAfterRedirect: true,
          }),
        );
      }
    };

    const determineIfInternalUser = (account) => {
        // Implement your logic to determine if the user is internal
        // For example, you might check the domain of the user's email
        return account.username.endsWith(process.env.REACT_APP_INTERNAL_USER_EMAIL_DOMAIN);
    };

    const handleOpen = () => setModalState({ ...modalState, open: true });
    const handleClose = () => setModalState({ ...modalState, open: false });
    const handleOtpOpen = () => setModalState({ ...modalState, open: false, otpOpen: true });
    const handleOtpClose = () => setModalState({ ...modalState, otpOpen: false });

    const handleBlur = async (e) => {
        const fieldName = e.target.name;
        await trigger(fieldName);
    };
     const handleVLClose =()=>{
        setIsResendVL(false);
        setErrorMessage("")
    }
    const handleResendVerificationLink = async () => {
      try {
        dispatch(alertActions.clear());
        await dispatch(
          registrationActions.resendVerificationLink({ emailAddress: email }),
        ).unwrap();
        dispatch(
          alertActions.success({
            showAfterRedirect: true,
            message: emailSentLabels.message1,
            header: emailSentLabels.header,
          }),
        );
      } catch (error) {
        dispatch(
          alertActions.error({
            message: error.message ? ERR_MSG["073"] : error,
            header: "Verification Failed",
          }),
        );
      } finally {
        handleVLClose();
      }
    };
   
    return (
        <div>
            <Typography component="div" className="mobilebanner">
                <Typography component="div" className="loginheader">
                    <Typography component="h1" variant="h5" className="Logincontent">
                        {labels.loginHeader}
                    </Typography>
                </Typography>
                <div className="paper">
                    <form className="form" onSubmit={handleSubmit(onSubmit)} autoComplete="off" method="post">
                        <CustomFormControl
                            id="Email"
                            label="Email Address"
                            type="text"
                            register={register}
                            errors={errors}
                            handleBlur={handleBlur}
                        />
                        <Typography component="div" className="PasswordInput">
                            <PasswordInput
                                control={control}
                                name="Password"
                                label="Password"
                                rules={{ required: 'Password is required' }}
                                errors={errors}
                                handleBlur={handleBlur}
                                isPasswordValid={true}
                            />
                        </Typography>
                        <Link href="#" onClick={handleOpen} variant="body2" className="ResetPassword">
                            {labels.resetPwdButtonLabel}
                        </Link>
                        <Typography component="div" className="loginbuttonfixed">
                            <Typography component="div" className="loginbuttonfixedbutton">
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="Loginbutton Loginbuttonheight"
                                    disabled={!isValid}
                                >
                                    Login External Users
                                </Button>
                                <Typography className="Orcontent">or</Typography>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="cancelButton"
                                    onClick={handleSSOLogin}
                                >
                                    Login WG Users Only
                                </Button>
                                <Grid container>
                                    <Grid item className="accountSignup">
                                        <div>Don’t have an account? </div>
                                        <Link href="./register" variant="body2">
                                            {labels.signUpLabel}
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Typography>
                        </Typography>
                    </form>
                </div>
            </Typography>
            <ForgotPassword open={modalState.open} handleClose={handleClose} onSubmitToOTP={handleOtpOpen} />
           { isResendVL &&   <ModalPopup
                         header={`Login Failed`}
                    message1={errorMessage}
                    //message2={verifiedRegistrationLabels.message2}
                    errors={true}
                    btnPrimaryText={`Resend Verification Link`}
                    btnSecondaryText={`Close`}
                    handlePrimaryClick={() => handleResendVerificationLink()}
                    handleSecondaryClick={() => handleVLClose()}
                    className="verifiedRegistrationpopup"
                />}
        </div>
    );
}

export default Login;
